<template>
  <div class="financialMain">
    <div class="title">
      <img class="title_img"
           src="../../assets/images/05/zizhi_icon.png"
           alt="">
      金融资质管理
    </div>
    <el-form :inline="true"
             :model="formInline"
             class="financial-search"
             label-position="right">
      <el-form-item label="公司名称"
                    size="small">
        <el-autocomplete class="inline-input"
                         size='small'
                         v-model="inputName"
                         :fetch-suggestions="querySearch"
                         placeholder="请输入内容"
                         :trigger-on-focus="false"
                         @select="handleSelectChange">
        </el-autocomplete>
        <!-- <el-input v-model="formInline.companyName"
                  placeholder="请输入公司名称"></el-input> -->
      </el-form-item>
      <el-button type="primary"
                 size="small"
                 class="search_btn"
                 @click="handleSearchClick">查询</el-button>
      <!-- <el-form-item class="btn_box">
        <el-button type="warning" size="small" class="add_btn">添加</el-button>
      </el-form-item> -->
    </el-form>
    <div class="financial-container">
      <el-table :data="data.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         label="序号"
                         align="center"
                         type="index"
                         min-width="40"
                         fixed>
        </el-table-column>

        <el-table-column label="公司信息">
          <template slot-scope="scope">
            <div><span>公司名称：</span>{{scope.row.companyName}}</div>
            <div><span>统一社会信用代码：</span>{{scope.row.busiCode}}</div>
          </template>
        </el-table-column>
        <el-table-column label="法人信息">
          <template slot-scope="scope">
            <div><span>法人姓名：</span>{{scope.row.toAccName}}</div>
            <div><span>法人身份证号：</span>{{scope.row.transCardId}}</div>
            <div><span>企业手机号：</span>{{scope.row.transMobile}}</div>

          </template>
        </el-table-column>
        <el-table-column label="银行信息">
          <template slot-scope="scope">
            <div><span>开户行名称：</span>{{scope.row.toBankName}}</div>
            <div><span>开户行账号：</span>{{scope.row.toAccNo}}</div>
            <div><span>开户行支行名称：</span>{{scope.row.toAccDept}}</div>
            <div><span>开户行省市：</span>{{scope.row.toProName}}</div>
            <div><span>开户行区县：</span>{{scope.row.toCityName}}</div>
          </template>

        </el-table-column>
        <el-table-column class-name="legalID"
                         label="法人身份信息"
                         align="left"
                         width="105">
          <template slot-scope="scope">
            <!-- {{scope.row.qualifiedInfo.businessLicense}} -->
            <div class="legalIDList">
              <p>正面：</p><img @click="handlePactClick(scope.row.idNumberPhonePositive.imgUrl)"
                   :src='scope.row.idNumberPhonePositive.thumbnailsUrl'
                   alt="营业执照">
            </div>
            <div class="legalIDList">
              <p>反面：</p><img @click="handlePactClick(scope.row.idNumberPhoneContrary.imgUrl)"
                   :src='scope.row.idNumberPhoneContrary.thumbnailsUrl'
                   alt="危险品经营许可证">
            </div>
          </template>
        </el-table-column>

        <el-table-column label="平台审核"
                         header-align="center"
                         min-width="70">
          <template slot-scope="scope">
            <div v-if="scope.row.auditType==='00'"
                 class="status-style wait">待审核</div>
            <div v-else-if="scope.row.auditType==='01'"
                 class="status-style failure">未通过</div>
            <div v-else-if="scope.row.auditType==='02'"
                 class="status-style freeze"><span>账户</span> <span>冻结</span></div>
            <div v-else-if="scope.row.auditType==='03'|scope.row.auditType==='04'"
                 class="status-style pass"><span>审核</span> <span>通过</span></div>
          </template>
        </el-table-column>
        <el-table-column label="涌泉平台">
          <template slot-scope="scope">
            <div>
              <span>1.涌泉审核：</span>
              <p v-if="scope.row.auditType==='04'">是</p>
              <p v-else>否</p>
            </div>
            <div>
              <span>2.涌泉开户：</span>
              <p v-if="scope.row.yqAccount==='02'">是</p>
              <p v-else>否</p>
            </div>
            <div>
              <span>3.涌泉注册：</span>
              <p v-if="scope.row.yqRegistered==='02'">是</p>
              <p v-else>否</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         label="操作"
                         width="120"
                         align="center"
                         class-name="operation">
          <template slot-scope="scope">
            <el-button class="audit"
                       @click="handleAuditClick(scope.row.financialId)">
              审核
            </el-button>
            <el-button class="confirm"
                       @click="handleConfirmClick(scope.row.financialId)">
              确认开户
            </el-button>
            <el-button class="update"
                       @click="handleUpdateClick(scope.row.financialId)">
              修改
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="信息审核"
               :visible.sync="showOwnerDetails"
               class="biddingTable"
               trigger="click"
               :before-close="handleClose">
      <div class="auditList">
        <div class="auditStyle">审核：</div>
        <el-radio v-model="audit.status"
                  label="03">审核通过</el-radio>
        <el-radio v-model="audit.status"
                  label="01">审核未通过</el-radio>
      </div>
      <!-- <div class="auditList">
        <div class="auditStyle">备注：</div>
        <el-input
          :disabled="audit.status==='2'?true:false"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8}"
          v-model="audit.remarks"
          placeholder="请输入审核内容"
        ></el-input>
      </div> -->
      <el-button class="auditConfirm"
                 @click="handleAuditConfirmClick">确定</el-button>
    </el-dialog>
    <div class="imgTab">
      <el-dialog :title="titlename"
                 :visible.sync="imgTab">
        <el-carousel trigger="click"
                     arrow="always"
                     indicator-position='none'
                     :autoplay="false">
          <el-carousel-item v-for="(item,index) in imgList"
                            :key="index">
            <div class="imgMain">
              <img :src=item
                   alt="">
            </div>
            <div class="imgNums">{{index+1}}/{{imgList.length}}</div>
          </el-carousel-item>
        </el-carousel>
      </el-dialog>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{data.total}}条记录</span>
      <el-pagination :page-size="data.pageSize"
                     layout="prev, pager, next"
                     :total="data.total"
                     background>
      </el-pagination>

    </div>
  </div>
</template>

<script>
import { getFinancial, financialAudie, confirmAccouont } from 'apis/index'
export default {
  name: 'Container',
  data () {
    return {
      formInline: {
        companyName: '',
        contacts: ''
      },
      data: {},
      showOwnerDetails: false,
      audit: {
        status: '1',
        remarks: ''
      },
      financialId: '',
      inputName: '',
      companyList: [],
      imgTab: false,
      titlename: '',
      imgList: []
    }
  },
  methods: {
    getData () { // 获取信息
      getFinancial().then(res => {
        if (res.data.code === 0) {
          this.data = res.data.data.VhbUserFinancial
          this.companyList = res.data.data.vhbCompanyList
        }
      })
    },
    handlePactClick (item) { // 点击查看合同图片
      this.imgList = []
      this.imgList.push(item)
      this.titlename = '身份证照片'
      this.imgTab = true
      // console.log(this.imgList)
    },
    handleAuditClick (id) { // 审核
      this.showOwnerDetails = true
      this.financialId = id
    },
    handleAuditConfirmClick () { // 确认审核
      financialAudie({
        financialId: this.financialId,
        auditType: this.audit.status
      }).then(res => {
        if (res.data.code === 0) {
          this.showOwnerDetails = false
          this.financialId = ''
          this.getData()
        }
      })
    },
    handleConfirmClick (item) { // 确认开户
      // console.log(item)
      confirmAccouont({
        financialId: item
      }).then(res => {
        // console.log(res)
        if (res.data.code === '0000') {
          this.$alert('确认开户成功', {
            confirmButtonText: '确定',
            callback: action => {
              this.getData()
            }
          })
        } else {
          this.$message({
            message: 'code:' + res.data.code + ', desc:' + res.data.desc,
            type: 'error'
          })
        }
      })
      // confirmAccount({
      //   financialId: item
      // }).then(res => {
      //   if (res.data.code === 0) {

      //   } else {

      //   }
      // })
    },
    handleSelectChange () {
      for (var i = 0; i < this.csvS.length; i++) {
        if (this.inputName === this.csvS[i].value) {
          this.companyId = this.csvS[i].id
        }
      }
    },
    handleSearchClick () { // 查询
      getFinancial({
        companyName: this.inputName
      }).then(res => {
        // console.log(res)
        if (res.data.code === 0) {
          this.data = res.data.data.VhbUserFinancial
        }
      })
    },
    handleUpdateClick (item) { // 修改用户金融审核
      this.$router.push({ path: 'financial/updateFinancial', query: { id: item } })
    },
    handleClose (done) { // 信息审核关闭按钮
      this.financialId = ''
      done()
    },
    querySearch (queryString, cb) { // 模糊查询
      var csvS = this.csvS
      cb(csvS)
    },
    createFilter (queryString) { // 模糊查询
      return (companyList) => {
        return (companyList.companyName.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    }

  },
  mounted () {
    this.getData()
  },
  watch: {
    inputName: function () { // 模糊查询
      this.csvS = []
      var len = this.companyList.length
      var arr = []
      for (var i = 0; i < len; i++) {
        if (this.companyList[i].companyName.indexOf(this.inputName) >= 0) {
          arr.push(this.companyList[i])
        }
      }
      // el-autocomplete元素要求数组内是对象，且有value属性
      for (var j = 0; j < arr.length; j++) {
        var obj = { value: '' }
        obj.value = arr[j].companyName
        obj.id = arr[j].companyId
        this.csvS.push(obj)
      }
    }
  }
}
</script>

<style lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.financialMain
  height 100%
  margin-left 20px
  margin-top 10px
  margin-right 20px
  .title
    width 100%
    height 46px
    line-height 46px
    color #212832
    border-bottom 1px solid #cfd5dc
    .title_img
      background #9231ff
      border-radius 50%
  .financial-search
    padding-left 20px
    padding-right 20px
    padding-top 10px
    .el-input
      width 210px
    .el-form-item
      margin-bottom 10px
    .search_btn
      margin-top 4px
      searchBtn()
    .btn_box
      float right
      .el-form-item__content
        line-height 30px
        .el-button
          width 80px
          height 30px
  .financial-container
    height calc(100% - 168px)
    .el-table
      background #f7f9fb
      th
        background #e7f0f8
        .cell
          size12()
      td
        .cell
          size12()
      .legalID
        .legalIDList
          margin-top 3px
          overflow hidden
          img
            width 80px
            height 48px
            margin-left 3px
      .status-style
        width 40px
        height 40px
        border-radius 50%
        margin 0 auto
        border 1px solid transparent
        size10()
        line-height 40px
        text-align center
      .wait
        background #ffffff
        color #1B88EE
        border 1px solid #CFD5DC
      .progress
        progress()
      .pass
        background #00D5B9
        color #fff
        padding-top 5px
        span
          display block
          width 40px
          height 15px
          line-height 15px
      .failure
        failure()
      .freeze
        freeze()
        padding-top 5px
        span
          display block
          width 40px
          height 15px
          line-height 15px
      .el-button
        size12()
        margin-bottom 10px
        margin-left 10px
        width 78px
      .operation
        .el-button
          size12()
          margin-bottom 10px
          margin-left 10px
          width 78px
          height 28px
          padding 0
        .audit
          background #1B88EE
          border 1px solid #1B88EE
          color #ffffff
        .confirm
          background #00D5B9
          border 1px solid #00D5B9
          color #ffffff
        .update
          border 1px solid #1B88EE
          background #fff
          color #1B88EE
  .el-dialog
    width auto
    width 728px
    .el-dialog__header
      height 42px
      padding 0 20px 0
      background #1b88ee
      .el-dialog__title
        line-height 42px
        font-size 13px
        color #fff
        float left
      .el-dialog__headerbtn
        top 12px
        right 12px
        .el-dialog__close
          color #fff
          font-size 20px
    .el-dialog__body
      padding 15px 20px
      .auditList
        margin-top 30px
        margin-left 68px
        .auditStyle
          margin-right 5px
          text-align right
          width 70px
          float left
          span
            color #858C96
            font-size 12px
            display block
            text-align center
        .el-textarea
          width 475px
          margin-left 12px
      .auditConfirm
        margin 50px 300px
        padding 7px 24px
        background #1B88EE
        color #fff
      .imgMain
        width 348px
        height 300px
        position relative
        margin 0 auto
        img
          height 100%
          position absolute
          top 50%
          left 50%
          transform translate(-50%, -50%)
      .imgNums
        position absolute
        bottom 0px
        left 50%
        transform translatex(-50%)
  .imgTab
    .el-dialog
      width 90vw
      height 90%
      margin-top 2vw !important
      .el-dialog__header
        height 42px
        padding 0 20px 0
        text-align left
        background #1b88ee
        line-height 42px
        .el-dialog__title
          font-size 13px
          color #fff
      .el-dialog__headerbtn
        top 12px
        right 12px
        .el-dialog__close
          color #fff
          font-size 20px
      .el-dialog__body
        height calc(100% - 62px)
        padding 12px
        .el-carousel
          width 100%
          height 100%
          .el-carousel__container
            width 100%
            // background #f66
            height 100% !important
            margin 0 auto
          .el-carousel__arrow--left
            left 0px
            width 21px
            height 38px
            background none
            // background url('../../assets/images/02/left_n_page.png') no-repeat
            // &:hover
            // background url('../../assets/images/02/left_h_page.png') no-repeat
          .el-icon-arrow-right:before
            content '' !important
          .el-carousel__arrow--right
            right 0px
            width 21px
            height 38px
            background none
            // background url('../../assets/images/02/righe_n_page.png') no-repeat
            // &:hover
            // background url('../../assets/images/02/right_h_page.png') no-repeat
          .el-icon-arrow-left:before
            content '' !important
          .imgMain
            width 100%
            height 100%
            // background #0f0
            position relative
            // top 50%
            // left 50%
            // transform translate(-50%,-50%)
            img
              height 100%
              position absolute
              top 50%
              left 50%
              transform translate(-50%, -50%)
          .imgNums
            position absolute
            bottom 10px
            left 50%
            transform translatex(-50%)
.pages
  margin-top 15px
  margin-bottom 15px
  .demonstartion
    float right
    line-height 45px
    color #5e656f
.el-table td, .el-table th
  vertical-align top
</style>
